export enum FileViewForm {
    UNKNOWN = 'UNKNOWN',
    DOCUMENT = 'DOCUMENT',
    IMAGE = 'IMAGE',
    THUMBNAIL = 'THUMBNAIL',
    PLAIN_TEXT = 'PLAIN_TEXT',
    RICH_DOCUMENT = 'RICH_DOCUMENT',
    PDF = 'PDF',
    MEDIA = 'MEDIA',
    AUDIO = 'AUDIO',
    VIDEO = 'VIDEO'
}
